import type { BlockthroughModule } from "@/ts/module";
import { appendHtmlToHead } from "@/utils/dom";
import { blockthroughTag } from "@/vendors/blockthroughTag";
export class Blockthrough implements BlockthroughModule {
    name = "Blockthrough" as const;
    async init(): Promise<void> {
        appendHtmlToHead(blockthroughTag);
        await Promise.resolve();
    }
}
